"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _localization = _interopRequireDefault(require("./../components/localization"));

var actions = _interopRequireWildcard(require("../store/actions"));

var _context = _interopRequireDefault(require("./../context"));

/**
 * Localization Container wrapper - it will display its children when its finished loading
 *
 * @class LocalizationContainer
 * @extends {Component}
 * @param retrieving - can be used for loading indicator
 * @param translationKeys - translation keys received from server
 * @param error - error during translation fetch
 * @param actions - object with all available actions
 */
var TranslatingLocalizationComp =
/*#__PURE__*/
function (_Component) {
  (0, _inherits2["default"])(TranslatingLocalizationComp, _Component);

  function TranslatingLocalizationComp() {
    (0, _classCallCheck2["default"])(this, TranslatingLocalizationComp);
    return (0, _possibleConstructorReturn2["default"])(this, (0, _getPrototypeOf2["default"])(TranslatingLocalizationComp).apply(this, arguments));
  }

  (0, _createClass2["default"])(TranslatingLocalizationComp, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.props.dispatch(this.props.actions.getLocalization());
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          retrieving = _this$props.retrieving,
          error = _this$props.error,
          translationKeys = _this$props.translationKeys,
          rest = (0, _objectWithoutProperties2["default"])(_this$props, ["retrieving", "error", "translationKeys"]);
      return _react["default"].createElement(_localization["default"], (0, _extends2["default"])({
        retrieving: false,
        translationKeys: translationKeys,
        error: null
      }, rest));
    }
  }]);
  return TranslatingLocalizationComp;
}(_react.Component);

TranslatingLocalizationComp.propTypes = {
  retrieving: _propTypes["default"].bool,
  translationKeys: _propTypes["default"].object,
  error: _propTypes["default"].string,
  actions: _propTypes["default"].object,
  dispatch: _propTypes["default"].func.isRequired
};

var mapStateToProps = function mapStateToProps(state) {
  return {
    retrieving: state.localize.retrieving,
    translationKeys: state.localize.translationKeys,
    error: state.localize.error
  };
};

var connect = function connect(mapState) {
  return function (WrappedComponent) {
    return function (props) {
      var _useContext = (0, _react.useContext)(_context["default"]),
          state = _useContext.state,
          dispatch = _useContext.dispatch;

      return _react["default"].createElement(WrappedComponent, (0, _extends2["default"])({}, props, mapState(state, props), {
        dispatch: dispatch,
        actions: actions
      }));
    };
  };
};

var TranslatingLocalizationContainer = connect(mapStateToProps)(TranslatingLocalizationComp);
var _default = TranslatingLocalizationContainer;
exports["default"] = _default;